module.exports = __webpack_public_path__ + "img/bp.cb279ca1.jpg";